var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeedlessClaveSamplePort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.8,41.5l-1.4-16.8h.6v-5.7h-1.1l-.3-3.3,1.5-.4-.3-1-1.3.3-.2-2.4,1.7-.5-.3-1-1.6.4-.2-2.3,2-.6-.3-1-1.6.7-.3-3.2h-15.5l-.3,4.3-1.9.5.3,1,1.5-.4-.2,2.3-1.7.5.3,1,1.4-.4-.2,2.5-1.4.4.3,1,1.1-.3-.2,2h-1.2v5.6h.6l-1.4,16.8h-6.5v7.5l3.9,10.4v15.9h27.3v-16l3.3-10.3v-7.6h-6.4v.1Zm-18-31.7l7.4-2-.3-1-7.1,1.9.2-3h13.7l.2,2.4-14.4,3.9.3-2.2Zm-.3,3.4l14.6-4,.2,2.3-15,4.1.2-2.4Zm-.3,3.5l15.2-4.1.2,2.4-7.7,2.1.3,1,7.6-2.1.2,3h-15.9l.1-2.3Zm-.6,7.9h16.8l1.4,16.8h-19.6l1.4-16.8Zm24.7,24.2l-3.3,10.3v15.1h-25.4v-15l-3.9-10.4v-6.4h32.5v6.4h.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedlessClaveSamplePort);
export default __webpack_public_path__ + "static/media/needlessClaveSamplePort.a029dcd4534832ebc3e128a5642b7444.svg";
export { ForwardRef as ReactComponent };